import * as XLSX from 'xlsx-js-style'

const createOutputForEmptyCells = (params) => {
    if ([null, undefined, ''].includes(params.value))
        return ' '

    return params.value
}

const getGridsAsExcel = (state) => {
    const {
        gridOptions,
        butaneGridOptions,
        isoButaneGridOptions,
        normalButaneGridOptions,
        propaneGridOptions,
        condensateGridOptions
    } = state

    const nglObj = gridOptions.api.getDataAsExcel({
        sheetName: 'NGL',
        processCellCallback: createOutputForEmptyCells,
        suppressTextAsCDATA: true
    })
    const butaneObj = butaneGridOptions.api.getDataAsExcel({
        sheetName: 'Butane',
        processCellCallback: createOutputForEmptyCells,
        suppressTextAsCDATA: true
    })
    const isoButaneObj = isoButaneGridOptions.api.getDataAsExcel({
        sheetName: 'Iso-Butane',
        processCellCallback: createOutputForEmptyCells,
        suppressTextAsCDATA: true
    })
    const propaneObj = propaneGridOptions.api.getDataAsExcel({
        sheetName: 'Propane',
        processCellCallback: createOutputForEmptyCells,
        suppressTextAsCDATA: true
    })
    const condensateObj = condensateGridOptions.api.getDataAsExcel({
        sheetName: 'Condensate',
        processCellCallback: createOutputForEmptyCells,
        suppressTextAsCDATA: true
    })
    const normalButaneObj = normalButaneGridOptions.api.getDataAsExcel({
        sheetName: 'Normal Butane',
        processCellCallback: createOutputForEmptyCells,
        suppressTextAsCDATA: true
    })

    return {
        nglObj,
        butaneObj,
        isoButaneObj,
        propaneObj,
        condensateObj,
        normalButaneObj
    }
}

const getGridsAsXml = (grids) => {
    const {
        nglObj,
        butaneObj,
        isoButaneObj,
        propaneObj,
        condensateObj,
        normalButaneObj
    } = grids
    const parser = new DOMParser();

    const nglXml = parser.parseFromString(nglObj, 'text/xml')
    const butaneXml = parser.parseFromString(butaneObj, 'text/xml')
    const isoButaneXml = parser.parseFromString(isoButaneObj, 'text/xml')
    const propaneXml = parser.parseFromString(propaneObj, 'text/xml')
    const condensateXml = parser.parseFromString(condensateObj, 'text/xml')
    const normalButaneXml = parser.parseFromString(normalButaneObj, 'text/xml')

    return {
        nglXml,
        butaneXml,
        isoButaneXml,
        propaneXml,
        condensateXml,
        normalButaneXml
    }
}

export const getWorkSheets = (state) => {
    const stringGrids = getGridsAsExcel(state)
    const {
        nglXml,
        butaneXml,
        isoButaneXml,
        propaneXml,
        condensateXml,
        normalButaneXml
    } = getGridsAsXml(stringGrids)

    // wb - workbook
    // ws - worksheet
    const wbNgl = XLSX.read(new XMLSerializer()
        .serializeToString(nglXml), { type: 'binary' })
    const wbButane = XLSX.read(new XMLSerializer()
        .serializeToString(butaneXml), { type: 'binary' })
    const wbIsoButane = XLSX.read(new XMLSerializer()
        .serializeToString(isoButaneXml), { type: 'binary' })
    const wbPropane = XLSX.read(new XMLSerializer()
        .serializeToString(propaneXml), { type: 'binary' })
    const wbCondensate = XLSX.read(new XMLSerializer()
        .serializeToString(condensateXml), { type: 'binary' })
    const wbNormalButane = XLSX.read(new XMLSerializer()
        .serializeToString(normalButaneXml), { type: 'binary' })

    const wsNgl = wbNgl.Sheets[wbNgl.SheetNames[0]]
    const wsButane = wbButane.Sheets[wbButane.SheetNames[0]]
    const wsIsoButane = wbIsoButane.Sheets[wbIsoButane.SheetNames[0]]
    const wsPropane = wbPropane.Sheets[wbPropane.SheetNames[0]]
    const wsCondensate = wbCondensate.Sheets[wbCondensate.SheetNames[0]]
    const wsNormalButane = wbNormalButane.Sheets[wbNormalButane.SheetNames[0]]

    return {
        wsNgl,
        wsButane,
        wsIsoButane,
        wsPropane,
        wsCondensate,
        wsNormalButane
    }
}